import {css} from '@emotion/react'

const cssCollapseButton = css({
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    appearance: 'none',
    fontSize: 8,
    color: '#888',
    padding: 0,
    border: 'none',
    margin: 'auto',
})

const cssCollapseButtonBottom = css({
    width: 40,
    height: 12,
    right: 0,
    left: 0,
})

const cssCollapseButtonBottomCollapsed = css({
    top: '100%',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
})

const cssCollapseButtonBottomExpanded = css({
    bottom: 0,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
})

const cssCollapseButtonLeft = css({
    width: 12,
    height: 40,
    top: 0,
    bottom: 0,
})

const cssCollapseButtonLeftCollapsed = css({
    right: '100%',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
})

const cssCollapseButtonLeftExpanded = css({
    left: 0,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
})

const cssCollapseButtonRight = css({
    width: 12,
    height: 40,
    top: 0,
    bottom: 0,
})

const cssCollapseButtonRightCollapsed = css({
    left: '100%',
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
})

const cssCollapseButtonRightExpanded = css({
    right: 0,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
})

const cssCollapseButtonTop = css({
    width: 40,
    height: 12,
    right: 0,
    left: 0,
})

const cssCollapseButtonTopCollapsed = css({
    bottom: '100%',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
})

const cssCollapseButtonTopExpanded = css({
    top: 0,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
})

export const CollapseButton = ({position, isExpanded, ...props}) => {
    if (! position) {
        return null
    }

    const csss = [
        cssCollapseButton,

        ...(
            isExpanded ?
                {
                    bottom: [
                        cssCollapseButtonBottom,
                        cssCollapseButtonBottomExpanded
                    ],

                    left: [
                        cssCollapseButtonLeft,
                        cssCollapseButtonLeftExpanded,
                    ],

                    right: [
                        cssCollapseButtonRight,
                        cssCollapseButtonRightExpanded,
                    ],

                    top: [
                        cssCollapseButtonTop,
                        cssCollapseButtonTopExpanded,
                    ],
                }[position]
                :
                {
                     bottom: [
                        cssCollapseButtonBottom,
                        cssCollapseButtonBottomCollapsed
                    ],

                    left: [
                        cssCollapseButtonLeft,
                        cssCollapseButtonLeftCollapsed,
                    ],

                    right: [
                        cssCollapseButtonRight,
                        cssCollapseButtonRightCollapsed,
                    ],

                    top: [
                        cssCollapseButtonTop,
                        cssCollapseButtonTopCollapsed,
                    ],
               }[position]
        ),
    ]

    const children = isExpanded ?
        {
            bottom: '▲',
            left: '▶',
            right: '◀',
            top: '▼',
        }[position]
        :
        {
            bottom: '▼',
            left: '◀',
            right: '▶',
            top: '▲',
        }[position]

    return (
        <button
            css={csss}
            {...props}
        >
            {children}
        </button>
    )
}
